module.exports = __webpack_public_path__ + "img/screen-manual-12.fb29578d.png";